import colors from '@theme/colors';
import { StyleSheet } from 'react-native';

const styles = StyleSheet.create({
  contentContainer: {
    flex: 1,
    padding: 20,
  },
  footerContainer: {
    borderTopWidth: 1,
    padding: 20,
  },
  modalContainer: {
    backgroundColor: colors.neutral.cotton,
    flex: 1,
  },
});

export default styles;
